@if (statisticService.isLoading()) {
    <app-loading class="h-full" />
} @else {
    <div
        cdkDropList
        cdkDropListOrientation="mixed"
        class="flex flex-wrap gap-2 justify-start items-stretch w-full"
        (cdkDropListDropped)="moveStatistic($event)">
        @for (computedStatistic of statisticService.computedStatisticList(); track computedStatistic.id) {
            <div
                cdkDrag
                class="flex-grow h-full cursor-move"
                [class]="statisticService.getClassByRenderType(computedStatistic)"
                (cdkDragEnded)="isDragging.set(false)"
                (cdkDragStarted)="isDragging.set(true)">
                <app-statistic-edit-order
                    class="statistic-unit"
                    [computedStatistic]="computedStatistic" />
            </div>

            @if (shouldRenderHalfPlaceholder($index) && !isDragging()) {
                <div
                    class="stat-half-placeholder"
                    [class]="STATISTIC_CLASS_HALF"></div>
            }
        } @empty {
            <div class="flex justify-center items-center m-auto w-full h-fit">
                <app-no-data-to-display
                    iconSize="5x"
                    information="noDataFound" />
            </div>
        }
    </div>
}
